import React from "react";
// import { useSubheader } from "../../_metronic/layout";

const About = () => {
//   const suhbeader = useSubheader();
//   suhbeader.setTitle("Customers");

  return <>About</>;
};

export default About